import PortalLoader from './PortalLoader';

export default PortalLoader;
